import React from "react";
import { Col, Container, Row } from "reactstrap";

const Privacy = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>Privacy</Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Privacy;
